import { ExternalLink } from "lucide-react";

import { NavigationLink } from "../NavigationLink";
import { useNavigationActiveState } from "../hooks";
import { SubMenuItemType } from "../types";

import { ICON_CONTAINER_STYLES, TEXT_STYLES } from "./constants";

interface SubMenuItemProps {
  item: SubMenuItemType;
  className?: string;
  textClassName?: string;
  iconSize?: "main" | "nested";
  showExternalIcon?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  skipNavigation?: boolean;
}

export const SubMenuItem = ({
  item,
  className = "",
  textClassName = "",
  iconSize = "main",
  showExternalIcon = true,
  onClick,
  children,
  skipNavigation = false,
}: SubMenuItemProps) => {
  const { isItemActive } = useNavigationActiveState();
  const isActive = isItemActive(item);
  const isExternal = item.href?.startsWith("http://") || item.href?.startsWith("https://");
  const iconContainerStyle =
    iconSize === "main" ? ICON_CONTAINER_STYLES.main : ICON_CONTAINER_STYLES.nested;

  const textStyle = isActive ? TEXT_STYLES.active : TEXT_STYLES.inactive;

  const content = (
    <div className={`flex flex-row items-center gap-3 ${className}`}>
      {item.icon && (
        <span className={iconContainerStyle}>
          {typeof item.icon === "function" ? (
            <item.icon className={iconSize === "main" ? "h-3.5 w-3.5" : "h-2.5 w-2.5"} />
          ) : (
            item.icon
          )}
        </span>
      )}
      <span className={`${textStyle} ${textClassName}`}>{item.name}</span>
      {showExternalIcon && isExternal && <ExternalLink className="ml-auto h-3 w-3 opacity-40" />}
      {children}
    </div>
  );

  if (item.onClick || onClick) {
    return (
      <div onClick={item.onClick || onClick} className="cursor-pointer">
        {content}
      </div>
    );
  }

  if (item.href && !skipNavigation) {
    return <NavigationLink to={item.href}>{content}</NavigationLink>;
  }

  return content;
};
